import React from 'react';
import { SapperLogo } from './SapperLogo';
import { TopoPattern } from './TopoPattern';
import { Facebook, Instagram, Youtube, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0D0A] relative pt-20 pb-8 border-t border-sapper-olive/30 overflow-hidden" data-id="element-66">
      <TopoPattern opacity={0.03} data-id="element-67" />

      <div className="container mx-auto px-4 sm:px-6 relative z-10" data-id="element-68">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-16" data-id="element-69">
          <SapperLogo className="h-24 w-auto" data-id="element-70" />
          <div className="font-condensed font-black text-4xl sm:text-5xl text-sapper-white/20 uppercase tracking-tighter" data-id="element-71">
            WE CLEAR THE HEAT.
          </div>
        </div>

        {/* Link Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16" data-id="element-72">
          <div data-id="element-73">
            <h4 className="font-mono text-sm text-sapper-white font-bold tracking-widest mb-6 border-b border-sapper-olive/30 pb-2" data-id="element-74">
              SERVICES
            </h4>
            <ul className="space-y-3 font-sans text-sm text-sapper-gray" data-id="element-75">
              <li data-id="element-76">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-77">
                  AC Replacement
                </a>
              </li>
              <li data-id="element-78">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-79">
                  Mini-Splits
                </a>
              </li>
              <li data-id="element-80">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-81">
                  Heat Pump
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-83">
                  Repair
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-85">
                  Maintenance
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-87">
                  Financing
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-88">
            <h4 className="font-mono text-sm text-sapper-white font-bold tracking-widest mb-6 border-b border-sapper-olive/30 pb-2" data-id="element-89">
              SERVICE AREAS
            </h4>
            <ul className="space-y-3 font-sans text-sm text-sapper-gray" data-id="element-90">
              <li data-id="element-91">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-92">
                  Phoenix
                </a>
              </li>
              <li data-id="element-93">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-94">
                  Scottsdale
                </a>
              </li>
              <li data-id="element-95">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-96">
                  Mesa
                </a>
              </li>
              <li data-id="element-97">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-98">
                  Gilbert
                </a>
              </li>
              <li data-id="element-99">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-100">
                  Chandler
                </a>
              </li>
              <li data-id="element-101">
                <a href="#" className="hover:text-sapper-red transition-colors text-sapper-white font-medium" data-id="element-102">
                  View All Areas &gt;
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-103">
            <h4 className="font-mono text-sm text-sapper-white font-bold tracking-widest mb-6 border-b border-sapper-olive/30 pb-2" data-id="element-104">
              COMPANY
            </h4>
            <ul className="space-y-3 font-sans text-sm text-sapper-gray" data-id="element-105">
              <li data-id="element-106">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-107">
                  About
                </a>
              </li>
              <li data-id="element-108">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-109">
                  Projects
                </a>
              </li>
              <li data-id="element-110">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-111">
                  Blog
                </a>
              </li>
              <li data-id="element-112">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-113">
                  Careers
                </a>
              </li>
              <li data-id="element-114">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-115">
                  Reviews
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-116">
            <h4 className="font-mono text-sm text-sapper-white font-bold tracking-widest mb-6 border-b border-sapper-olive/30 pb-2" data-id="element-117">
              RESOURCES
            </h4>
            <ul className="space-y-3 font-sans text-sm text-sapper-gray" data-id="element-118">
              <li data-id="element-119">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-120">
                  HVAC Calculators
                </a>
              </li>
              <li data-id="element-121">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-122">
                  Estimator
                </a>
              </li>
              <li data-id="element-123">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-124">
                  Comparisons
                </a>
              </li>
              <li data-id="element-125">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-126">
                  Rebates
                </a>
              </li>
              <li data-id="element-127">
                <a href="#" className="hover:text-sapper-red transition-colors" data-id="element-128">
                  Warranty
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="h-px w-full bg-sapper-red/50 mb-8" data-id="element-129" />

        {/* Bottom Row */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-130">
          <div className="font-sans text-xs text-sapper-gray text-center md:text-left" data-id="element-131">
            © 2026 SAPPER HVAC. ALL RIGHTS RESERVED.{' '}
            <span className="mx-2" data-id="element-132">|</span> ROC #345678{' '}
            <span className="mx-2" data-id="element-133">|</span>{' '}
            <a href="#" className="hover:text-sapper-white" data-id="element-134">
              Privacy Policy
            </a>
          </div>

          <div className="flex gap-4" data-id="element-135">
            <a href="#" className="w-10 h-10 bg-sapper-olive/20 flex items-center justify-center text-sapper-gray hover:bg-sapper-red hover:text-sapper-white transition-colors" data-id="element-136">
              <Facebook className="w-5 h-5" data-id="element-137" />
            </a>
            <a href="#" className="w-10 h-10 bg-sapper-olive/20 flex items-center justify-center text-sapper-gray hover:bg-sapper-red hover:text-sapper-white transition-colors" data-id="element-138">
              <Instagram className="w-5 h-5" data-id="element-139" />
            </a>
            <a href="#" className="w-10 h-10 bg-sapper-olive/20 flex items-center justify-center text-sapper-gray hover:bg-sapper-red hover:text-sapper-white transition-colors" data-id="element-140">
              <Youtube className="w-5 h-5" data-id="element-141" />
            </a>
            <a href="#" className="w-10 h-10 bg-sapper-olive/20 flex items-center justify-center text-sapper-gray hover:bg-sapper-red hover:text-sapper-white transition-colors" data-id="element-142">
              <MapPin className="w-5 h-5" data-id="element-143" />
            </a>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-144">
          <span className="font-mono text-[10px] text-sapper-gray/30 tracking-[0.3em] uppercase" data-id="element-145">
            [ MISSION READY. PHOENIX BUILT. ]
          </span>
        </div>
      </div>
    </footer>;
}